module.exports = {
    key: "ac399df6ef88faf996d8146fb614900d",
    base: "https://api.openweathermap.org/data/2.5/",
  };